import { v4 as uuidv4 } from 'uuid';
import * as Sentry from '@sentry/react';
import { CookieService } from "../../../utils/cookieService";
import { setClickID } from "./userSlice";

/** clickID визита из cookie; при первом визите создаётся и запоминается. */
export const getOrCreateClickId = (): string => {
		let clickID = CookieService.get('clickID');

		if (!clickID) {
			clickID = `${uuidv4()}_${Date.now().toString()}`;

			CookieService.set('clickID', clickID, 36500);
		}

		return clickID;
};

export const setClickIDHandler = (dispatch: any) => {
		const clickID = getOrCreateClickId();

		Sentry.setUser({ id: clickID });
		dispatch(setClickID(clickID));
};
